import React from 'react'
import { Card } from 'react-bootstrap'

const HomeGoods = () => {
  return (
    <>
		<Card className="text-center rounded-0 no-border home-goods-card container">
				<Card.Body>
					<Card.Title className='home-goods-title'>Creating 3D Digital Assets</Card.Title>
					<Card.Text className='home-goods-content'>
					We can take ref erence images and dimensions from any product or environment and create realistic 3D models, digital twins , and virtual worlds that can then be used in VR, AR, web - based 3D viewers, and more. 3D visuals serve as the foundation for a high - quality VR/AR/3D experience. If the graphics leave something to be desired, so will the entire experience. When we create virtual worlds, we want it to be like the viewer is there — seeing every detail, feeling like they can reach out and touch their virtual surroundings.
					</Card.Text>
				</Card.Body>
			</Card>
    </>
  )
}

export default HomeGoods
